import { render, staticRenderFns } from "./DisplayPanelPortraitNT.vue?vue&type=template&id=65020410&"
import script from "./DisplayPanelPortraitNT.vue?vue&type=script&lang=js&"
export * from "./DisplayPanelPortraitNT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VImg,VSwitch})
